export const ROUTE_META = {
  home: {
    title: "Appazzola - Mobile App & Game Development",
    description:
      "Appazzola designs and builds mobile apps and games for businesses and teams that want polished, user-friendly products.",
    robots: "index,follow",
  },
  pawMergePrivacy: {
    title: "Privacy Policy for Paw Merge Idle | Appazzola",
    description:
      "Read the Appazzola privacy policy for Paw Merge Idle, including data collection, third-party services, retention, and contact information.",
    robots: "noindex,follow",
  },
  pawMergeTerms: {
    title: "Terms of Service for Paw Merge Idle | Appazzola",
    description:
      "Read the terms of service for Paw Merge Idle, including license, virtual items, in-app purchases, advertising, liability limits, and governing law.",
    robots: "noindex,follow",
  },
  pawMergeGame: {
    title: "Paw Merge Idle | Appazzola",
    description:
      "Paw Merge Idle - a cozy cat merge-and-idle game with rooms, cloud save, and leaderboards, available on Google Play and the App Store.",
    robots: "index,follow",
  },
  aetherDash: {
    title: "Privacy Policy for Aether Dash | Appazzola",
    description:
      "Read the Appazzola privacy policy for Aether Dash, including how leaderboard and local storage data are handled.",
    robots: "noindex,follow",
  },
  aetherDashGame: {
    title: "Aether Dash | Appazzola",
    description:
      "Play Aether Dash, a fast-paced shooter with Dash levels, Survival mode, and global leaderboards.",
    robots: "index,follow",
  },
  seas: {
    title: "SEAS Privacy Policy | Appazzola",
    description:
      "Read the Appazzola SEAS privacy policy, including notification data handling, diagnostics, retention, and deletion options.",
    robots: "noindex,follow",
  },
  pdfToolsPrivacy: {
    title: "Privacy Policy for PDF Toolbox by Appazzola | Appazzola",
    description:
      "Read the Appazzola privacy policy for PDF Toolbox by Appazzola, including on-device processing, subscriptions, ads, retention, and contact information.",
    robots: "noindex,follow",
  },
  pdfToolsTerms: {
    title: "Terms of Service for PDF Toolbox by Appazzola | Appazzola",
    description:
      "Read the terms of service for PDF Toolbox by Appazzola, including acceptable use, subscriptions, disclaimers, and liability limits.",
    robots: "noindex,follow",
  },
  rascalCatGame: {
    title: "Rascal Cat | Appazzola",
    description:
      "Play Rascal Cat from Appazzola on Google Play and the App Store.",
    robots: "index,follow",
  },
  rascalCatPrivacy: {
    title: "Privacy Policy for Rascal Cat | Appazzola",
    description:
      "Read the Rascal Cat privacy policy, including account data, cloud save, purchases, ads, analytics, and retention details.",
    robots: "noindex,follow",
  },
  rascalCatTerms: {
    title: "Terms and Conditions for Rascal Cat | Appazzola",
    description:
      "Read the Rascal Cat terms and conditions, including acceptable use, virtual items, purchases, liability limits, and governing law.",
    robots: "noindex,follow",
  },
};
